<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-layout>
    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-card>
        <v-card color="blue">
          <v-card-title flat class='white--text subheading'>{{ title | translate}}</v-card-title>
        </v-card>
        <v-card-text>
          <v-layout wrap>
            <v-flex>
              {{ question | translate }}
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-text>
          <v-layout wrap>
            <v-flex class="mt-4">
              <v-text-field solo v-model="answer" required clearable></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions class="mx-2">
          <v-btn color="#004884" small outline dark class="text-none" @click.native="doCancel">{{ 'BUTT_CANCEL' | translate}}</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="#004884" small dark class="text-none" @click.native="doOk">{{ 'BUTT_SAVE' | translate}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'DialogAskForString',
  props: [ 'title' ],
  components: {},
  data () {
    return {
      dialog: false,
      question: '',
      answer: '',
      okCallback: null,
    }
  },
  methods: {
    open: function (question, options, onSuccess) {
      this.question = question;
      this.onSuccess = onSuccess;
      if (options) {
        this.answer = options.defaultAnswer ? options.defaultAnswer : '';
        this.okCallback = options.on;
        if (options.title) this.title = options.title;
      }
      this.dialog = true
    },
    doCancel: function () {
      this.dialog = false;
    },
    doOk: function () {
      this.dialog = false
      if (this.onSuccess) {
        this.onSuccess(this.answer);
      }
    }
  },
  mounted () {
  }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/module/dialogs/DialogAskForString.vue